import React from "react";
import Modal from "components/common/Modal";
import { ContactInfo } from "./ModalShared";

const GeneralErrorModal = ({ show, onClose }) => {
  return (
    <Modal
      show={show}
      title="Desculpe, estamos passando por alguma instabilidade."
      onClose={onClose}
    >
      Por favor, tente novamente mais tarde.
      <br />
      <br />
      Se preferir, entre em contato por telefone com a Ouvidoria específica da
      empresa do seu produto:
      {ContactInfo}
    </Modal>
  );
};

export default GeneralErrorModal;
